import React, { useCallback, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ResultsIcon, SettingsIcon, SupportIcon, UsersIcon } from "affinityIcons";
import { isNil } from "ramda";

import { NavBar } from "affinityUI/structures/layout/navBar";
import { Restricted, useAuth } from "lib/auth";
import { UserInactivityHandler } from "lib/inactivityHandler";

import { CurrentUserPanel } from "../currentUserPanel";
import { CurrentUserButton } from "../currentUserPanel/userButton";

export const AppNavigation: React.FC = () => {
  const [, { currentUser }] = useAuth();
  const [showUserPanel, setShowUserPanel] = useState(false);

  const handleUserClick = useCallback(() => {
    setShowUserPanel(!showUserPanel);
  }, [showUserPanel]);

  const location = useLocation();
  useEffect(() => {
    setShowUserPanel(false);
  }, [location]);

  return (
    <>
      {!isNil(currentUser) && <UserInactivityHandler />}
      <NavBar>
        <NavBar.Menu>
          <Restricted permits={["view_patient"]}>
            <NavLink to="/patients">
              <NavBar.Item>
                <ResultsIcon /> Patients
              </NavBar.Item>
            </NavLink>
          </Restricted>
          <Restricted permits={["add_hospitalconfig", "change_hospitalconfig"]}>
            <NavLink to="/settings">
              <NavBar.Item>
                <SettingsIcon /> Settings
              </NavBar.Item>
            </NavLink>
          </Restricted>
          <Restricted permits={["view_user"]}>
            <NavLink to="/users">
              <NavBar.Item>
                <UsersIcon />
                Users
              </NavBar.Item>
            </NavLink>
          </Restricted>
          <NavLink to="/support">
            <NavBar.Item>
              <SupportIcon />
              Support
            </NavBar.Item>
          </NavLink>
        </NavBar.Menu>
        {!isNil(currentUser) && (
          <NavBar.Extra>
            <CurrentUserButton currentUser={currentUser} expanded={showUserPanel} onClick={handleUserClick} />
          </NavBar.Extra>
        )}
      </NavBar>
      {showUserPanel && !isNil(currentUser) && <CurrentUserPanel currentUser={currentUser} />}
    </>
  );
};
